import 'core-js/stable';

import '../../styles/gift_card.scss';
